// extracted by mini-css-extract-plugin
export default {"selected":"style_selected__kC58E","appear":"style_appear__lRVvw","selected-text":"style_selected-text__4O8l+"};